/* Home first fold: the visitor picks an industry or an AI employee and the window plays one real job from the
   use-case scenario data (snippets/ow-hero-demo.liquid), ending on an approval card they can click.
   Calm on load: the server renders a still frame and nothing moves until the visitor picks something.
   Reduced motion: frames swap with no animation. */
(function () {
  'use strict';
  var box = document.querySelector('[data-hx]');
  if (!box) return;
  var data, imgs;
  try { data = JSON.parse(box.querySelector('[data-hx-data]').textContent); imgs = JSON.parse(box.querySelector('[data-hx-img]').textContent); } catch (e) { return; }
  var reduce = false;
  try { reduce = matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}
  var body = box.querySelector('[data-hx-body]'), av = box.querySelector('[data-hx-av]');
  var nameEl = box.querySelector('[data-hx-name]'), roleEl = box.querySelector('[data-hx-role]');
  var countEl = box.querySelector('[data-hx-count]'), more = box.querySelector('[data-hx-more]');
  var pickBtns = Array.prototype.slice.call(box.querySelectorAll('[data-hx-pick]'));
  var cur = 'home', idx = 0;

  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function icon(i) { return '<svg class="os-icon" aria-hidden="true"><use href="#' + i + '"/></svg>'; }
  function arrow() { return '<svg class="os-icon os-icon--14" aria-hidden="true"><use href="#i-arrow-right"/></svg>'; }
  function anim(el, ms) { if (reduce || !el) return; el.style.setProperty('--hd', ms + 'ms'); el.classList.remove('hx-in'); void el.offsetWidth; el.classList.add('hx-in'); }

  /* must match frame() in tools/hero/build_hero.py */
  function render(job) {
    var log = job.log.map(function (l) {
      return '<li class="hx__l hx__l--' + esc(l[0]) + '">' + icon(l[0] === 'flag' ? 'i-flag' : 'i-check') + '<span>' + esc(l[1]) + '</span></li>';
    }).join('');
    body.innerHTML = '<p class="hx__task"><span class="hx__tk">Task</span><b>' + esc(job.q) + '</b></p><ul class="hx__log">' + log + '</ul>' +
      '<div class="hx__card"><p class="hx__ai">' + icon('i-sparkles') + 'Needs your approval</p><p class="hx__ct">' + esc(job.t) + '</p><p class="hx__cn">' + esc(job.n) + '</p>' +
      '<div class="hx__acts"><button type="button" class="os-btn os-btn--ghost os-btn--sm" data-hx-act="edit">Edit</button>' +
      '<button type="button" class="os-btn os-btn--secondary os-btn--sm" data-hx-act="reject">Reject</button>' +
      '<button type="button" class="os-btn os-btn--accent os-btn--sm" data-hx-act="approve">' + esc(job.cta) + '</button></div></div>';
    anim(body.querySelector('.hx__task'), 0);
    var items = body.querySelectorAll('.hx__l'), t = 160;
    for (var i = 0; i < items.length; i++) { anim(items[i], t); t += 280; }
    anim(body.querySelector('.hx__card'), t + 120);
  }

  function finish(ok, kb) {
    var p = data.picks[cur], job = p.jobs[idx], card = body.querySelector('.hx__card');
    if (!card) return;
    var last = idx >= p.jobs.length - 1;
    var done = document.createElement('div');
    done.className = 'hx__done' + (ok ? '' : ' hx__done--no');
    done.innerHTML = ok
      ? '<p class="hx__dh">' + icon('i-check-circle') + esc(job.dh) + '</p><ul>' + job.rows.map(function (r) { return '<li>' + esc(r) + '</li>'; }).join('') + '</ul>'
      : '<p class="hx__dh">' + icon('i-x-circle') + 'Rejected. Nothing goes out, and the task stays open for you.</p>';
    done.innerHTML += '<div class="hx__next"><button type="button" class="os-btn os-btn--secondary os-btn--sm" data-hx-act="next">' + (last ? 'Start over' : 'Next job') + arrow() + '</button></div>';
    card.parentNode.replaceChild(done, card);
    anim(done, 0);
    var nb = done.querySelector('[data-hx-act=next]'); if (nb && kb) nb.focus({ preventScroll: true });
  }

  function head(p) {
    var e = data.emps[p.emp];
    if (imgs[p.emp]) av.src = imgs[p.emp];
    nameEl.textContent = e.n + "'s computer";
    roleEl.textContent = e.r;
  }

  function show() {
    var p = data.picks[cur], e = data.emps[p.emp];
    head(p);
    countEl.textContent = 'Job ' + (idx + 1) + ' of ' + p.jobs.length;
    more.href = p.href || '/pages/' + p.uc;
    more.firstChild.nodeValue = p.href ? 'See ' + e.n + "'s skills" : 'See this job step by step';
    render(p.jobs[idx]);
  }

  pickBtns.forEach(function (b) {
    b.addEventListener('click', function () {
      cur = b.getAttribute('data-hx-pick'); idx = 0;
      pickBtns.forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
      show();
    });
  });

  body.addEventListener('click', function (ev) {
    var b = ev.target.closest && ev.target.closest('[data-hx-act]');
    if (!b) return;
    var act = b.getAttribute('data-hx-act');
    if (act === 'approve') finish(true, ev.detail === 0);
    else if (act === 'reject') finish(false, ev.detail === 0);
    else if (act === 'next') { idx = (idx + 1) % data.picks[cur].jobs.length; show(); }
    else if (act === 'edit' && !body.querySelector('.hx__note')) {
      var n = document.createElement('p'); n.className = 'hx__note';
      n.textContent = 'In the app you change the draft here, then approve it.';
      body.querySelector('.hx__card').appendChild(n); anim(n, 0);
    }
  });
})();
